import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const StoreSocialMedia = (_param)=>{
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-social-media-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-social-media-stores-v2__list"
    }, items.map(({ name , url , iconUrl  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: url,
            className: "store-social-media-stores-v2__list-item",
            "data-t": name
        }, /*#__PURE__*/ React__default.createElement("a", {
            href: url,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": name
        }, /*#__PURE__*/ React__default.createElement("img", {
            className: "store-social-media-stores-v2__icon",
            src: iconUrl,
            alt: name
        })))
    )));
};
var StoreSocialMedia$1 = StoreSocialMedia;

export { StoreSocialMedia$1 as default };
//# sourceMappingURL=StoreSocialMedia.js.map
